import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const HOMONYM_ACTIVITY_FRAGMENT = gql `
  fragment HomonymActivityFragment on HomonymActivity {
    rounds {
      steps {
        answer
        answerImage {
          image {
            ...AssetFragment
          }
        }
        description
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default HOMONYM_ACTIVITY_FRAGMENT;
